// Compliance Service API Service
// Endpoints: /api/v1/compliance-services

import axiosInstance from '@/app/api/axiosInstance';
import {
  ComplianceService,
  ComplianceServiceCreate,
  ComplianceServiceUpdate,
} from '@/app/types/compliance';
import { PaginatedResponse, ListQueryParams } from '@/app/types/api';

const API_PATH = '/compliance-services';

/**
 * List all compliance services with optional filtering
 */
export const listComplianceServices = async (
  params: ListQueryParams & {
    is_active?: boolean;
    category?: string;
  }
): Promise<PaginatedResponse<ComplianceService>> => {
  try {
    const response = await axiosInstance.get<PaginatedResponse<ComplianceService>>(
      `${API_PATH}/`,
      { params }
    );
    return response.data;
  } catch (error) {
    console.error('Failed to list compliance services:', error);
    throw error;
  }
};

/**
 * Get a single compliance service by ID
 */
export const getComplianceService = async (id: number): Promise<ComplianceService> => {
  try {
    const response = await axiosInstance.get<ComplianceService>(`${API_PATH}/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Failed to get compliance service ${id}:`, error);
    throw error;
  }
};

/**
 * Create a new compliance service
 */
export const createComplianceService = async (
  data: ComplianceServiceCreate
): Promise<ComplianceService> => {
  try {
    const response = await axiosInstance.post<ComplianceService>(`${API_PATH}/`, data);
    return response.data;
  } catch (error) {
    console.error('Failed to create compliance service:', error);
    throw error;
  }
};

/**
 * Update an existing compliance service
 */
export const updateComplianceService = async (
  id: number,
  data: ComplianceServiceUpdate
): Promise<ComplianceService> => {
  try {
    const response = await axiosInstance.patch<ComplianceService>(`${API_PATH}/${id}`, data);
    return response.data;
  } catch (error) {
    console.error(`Failed to update compliance service ${id}:`, error);
    throw error;
  }
};

/**
 * Delete a compliance service
 */
export const deleteComplianceService = async (id: number): Promise<void> => {
  try {
    await axiosInstance.delete(`${API_PATH}/${id}`);
  } catch (error) {
    console.error(`Failed to delete compliance service ${id}:`, error);
    throw error;
  }
};

